import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PurchaseShell } from "../features/purchase/PurchaseShell";
import { ItemForm } from "../features/purchase/ItemForm";
import { getItem } from "../api/masterItems";

// صفحة إضافة/تعديل مادة مركزية.
export default function PurchaseItemFormPage() {
  const { itemId } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(itemId ? null : {});
  const back = () => navigate("/purchases/items");

  useEffect(() => {
    if (!itemId) return;
    getItem(itemId).then(setItem).catch(back);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemId]);

  return (
    <PurchaseShell titleKey="items">
      {item ? <ItemForm item={itemId ? item : null} onDone={back} onCancel={back} /> : null}
    </PurchaseShell>
  );
}
